import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
  Container,
  Link,
} from "@mui/material";

import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const ContactSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fbf8f2",
        py: { xs: 6, md: 10 },
      }}
    >
      <Container>
        {/* HEADER */}
        <Box textAlign="center" maxWidth={750} mx="auto" mb={6}>
          <Typography
            sx={{
              color: "#ff8a00",
              fontWeight: 600,
              mb: 1,
              letterSpacing: 1,
            }}
          >
            Get in touch
          </Typography>

          <Typography variant="h4" fontWeight={700} mb={2}>
            Have water damage? We’re ready to help
          </Typography>

          <Typography color="text.secondary">
            Whether it’s an emergency or planned restoration service, our team
            is available 24/7 to assist you.
          </Typography>
        </Box>

        {/* CONTENT */}
        <Grid container spacing={3} justifyContent="center">
          {/* CUSTOMER SERVICE */}
          <Grid item xs={12} md={3}>
            <Card sx={{ height: "100%", borderRadius: 4, p: 2 }}>
              <CardContent>
                <HeadsetMicIcon color="success" fontSize="large" />

                <Typography variant="h6" mt={2} fontWeight={600}>
                  Customer Support
                </Typography>

                <Typography mt={1} color="text.secondary">
                  Call us anytime — we’re available 24 hours a day
                </Typography>

                <Typography mt={3} fontWeight={600}>
                  24/7 Emergency Service
                </Typography>

                <Link
                  href="tel:+18888352473"
                  underline="hover"
                  color="inherit"
                  sx={{ fontWeight: 600, display: "block", mt: 1 }}
                >
                  +1 (888) 835-2473
                </Link>
              </CardContent>
            </Card>
          </Grid>

          {/* FIND US */}
          <Grid item xs={12} md={3}>
            <Card sx={{ height: "100%", borderRadius: 4, p: 2 }}>
              <CardContent>
                <LocationOnIcon color="success" fontSize="large" />

                <Typography variant="h6" mt={2} fontWeight={600}>
                  Our Location
                </Typography>

                <Typography mt={1} color="text.secondary">
                  Rite Water Restoration
                  <br />
                  Bloomington, Indiana
                  <br />
                  Serving Nearby Areas
                </Typography>

                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    backgroundColor: "#ff8a00",
                    borderRadius: 5,
                    textTransform: "none",
                  }}
                  href="https://www.google.com/maps/search/?api=1&query=Bloomington+Indiana"
                  target="_blank"
                >
                  View Map
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* GREEN CTA CARD */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: "#4a944d",
                borderRadius: 6,
                height: "100%",
                p: { xs: 3, md: 4 },
                color: "#fff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Grid container spacing={2} alignItems="center">
                {/* TEXT */}
                <Grid item xs={12} md={7}>
                  <Typography variant="h6" fontWeight={600}>
                    Contact us online or
                    <br />
                    connect via social media
                  </Typography>

                  <Link
                    href="mailto:info@ritewaterrestoration.com"
                    color="inherit"
                    underline="hover"
                    sx={{ mt: 2, display: "block" }}
                  >
                    info@ritewaterrestoration.com
                  </Link>

                  <Box mt={3}>
                    <IconButton color="inherit">
                      <FacebookIcon />
                    </IconButton>
                    <IconButton color="inherit">
                      <InstagramIcon />
                    </IconButton>
                    <IconButton color="inherit">
                      <XIcon />
                    </IconButton>
                    <IconButton color="inherit">
                      <LinkedInIcon />
                    </IconButton>
                  </Box>
                </Grid>

                {/* IMAGE */}
                <Grid
                  item
                  xs={12}
                  md={5}
                  textAlign={{ xs: "center", md: "right" }}
                >
                  <Box
                    component="img"
                    src="https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/orange_glove_01.png"
                    alt="Water Restoration Equipment"
                    sx={{
                      maxHeight: 320,
                      width: "auto",
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactSection;
